import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface FearGreedData {
  value: string;
  value_classification: string;
  timestamp: string;
  time_until_update: string;
}

export const useFearGreedIndex = () => {
  return useQuery({
    queryKey: ['fear-greed-index'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('fetch-fear-greed');

      if (error) throw error;
      
      return data.data[0] as FearGreedData;
    },
    refetchInterval: 300000, // Refetch every 5 minutes (index updates once daily)
  });
};
